import React, { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Failed to parse stored user:', error);
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = () => {
    // HandCash OAuth URL - Using correct v3 API endpoint
    // Use environment variable for App ID (different for dev/production)
    const appId = process.env.REACT_APP_HANDCASH_APP_ID || '693317aae6cacf3e25be2165';
    
    console.log('Using HandCash App ID:', appId);
    
    // HandCash v3 uses this URL format
    const handcashAuthUrl = `https://app.handcash.io/#/authorizeApp?appId=${appId}`;
    
    // Redirect to HandCash for authentication
    window.location.href = handcashAuthUrl;
  };

  const handleAuthCallback = async () => {
    // This will be called from the AuthCallback page
    // The AuthCallback component will handle the URL params and call this
    return true;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    toast.success('Logged out successfully');
  };

  const value = {
    user,
    setUser,
    loading,
    login,
    logout,
    handleAuthCallback,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};